// @flow
import React from 'react'

export default class ErrorProfile extends React.Component<{errors: Array<Object>}> {
  render () {
    const errors = this.props.errors || []

    return (
      <ul className='error-profile'>
        {errors.map((errorMessage, index) => {
          return <li key={index}>{errorMessage}</li>
        })}
      </ul>
    )
  }
}

window.Components.ErrorProfile = React.createFactory(ErrorProfile)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/ErrorProfile.js